import { http } from "api/apiConfig";
import { STATUS, TRAVEL_AND_WORK_DURATION, WORKORDER, WORKORDER_BY_CUSTOMER_ID } from "constants/endpoints";
export const fetchWorkOrder = async (workOrderId) => {
    const { data } = await http.get(WORKORDER({ workOrderId: workOrderId }));
    return data;
};
export const fetchWorkOrderByCustomerId = async (customerId) => {
    const { data } = await http.get(WORKORDER_BY_CUSTOMER_ID(customerId));
    return data;
};
export const fetchTravelTime = async (workOrderId) => {
    const { data } = await http.get(TRAVEL_AND_WORK_DURATION(workOrderId));
    return data;
};
export const changeStatus = async (workOrderId, nextStatus) => {
    const url = STATUS(workOrderId);
    const body = { status: nextStatus };
    const { data } = await http.put(url, body);
    return data;
};
